<template>
  <v-row align="center" justify="center">
    <v-dialog v-model="conoceMasModal" persistent max-width="70%">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row align="center" justify="center">
            <img src="../assets/ok.svg" width="20%" class="ma-3 pa-1" />
          </v-row>

          <v-row align="center" justify="center">
            <h1>Comisión de okboy</h1>
          </v-row>

          <v-row align="center" justify="center">
            <v-col cols="8">
              <v-row align="center" justify="center">
                <p class="textCenter">
                  Nuestra comisión nos ayuda a que nuestra plataforma siga funcionando.
                  Al pagarla, nos ayudas a seguir brindando una mejor experiencia.
                </p>
              </v-row>
            </v-col>
          </v-row>

          <v-row align="center" justify="center">
            <v-col cols="8">
              <v-row align="center" justify="center">
                <v-btn color="primary" block rounded @click="close()">Entendido</v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapFields(["conoceMasModal"]),
  },
  methods: {
    close() {
      this.conoceMasModal = false;
    },
  },
};
</script>

<style>
.textCenter {
  text-align: center;
  text-justify: distribute;
}
</style>